module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/google-cf8e33e5.svg";